import { Button } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import React, { useCallback, useState } from 'react';

type Props = {
  onClick?: () => Promise<void>;
  buttonText: string;
  isLoading?: boolean;
};

export const ControlCardButton: FC<Props> = (props) => {
  const { onClick, buttonText, isLoading: isLoadingProp } = props;
  const isMobile = useIsMobile();
  const [isLoading, setIsLoading] = useState(false);

  const onButtonClick = useCallback(async () => {
    setIsLoading(true);
    await onClick?.();
    setTimeout(() => setIsLoading(false), 300);
  }, [onClick]);

  return (
    <Button
      style={{ width: isMobile ? 'auto' : 'fit-content' }}
      onClick={onButtonClick}
      variant="primary"
      loading={isLoading || isLoadingProp}
      size={isMobile ? 44 : 52}
    >
      {buttonText}
    </Button>
  );
};
